(function () {
  var defaultInternalHosts = [
    'olivemypickle.com',
    'www.olivemypickle.com',
    'omp-dev.myshopify.com'
  ];
  var scriptElement = document.currentScript;

  function normalizeHostname(hostname) {
    return String(hostname || '')
      .trim()
      .toLowerCase()
      .replace(/:\d+$/, '')
      .replace(/^www\./, '');
  }

  function addHost(hosts, value) {
    String(value || '')
      .split(',')
      .forEach(function (entry) {
        var host = entry.trim();

        if (!host) {
          return;
        }

        try {
          host = host.indexOf('://') > -1
            ? new URL(host).hostname
            : host.split('/')[0];
        } catch (error) {
          host = host.split('/')[0];
        }

        host = normalizeHostname(host);

        if (host) {
          hosts.add(host);
        }
      });
  }

  function getInternalHosts() {
    var hosts = new Set();
    var configuredHosts = scriptElement && scriptElement.dataset
      ? scriptElement.dataset.internalHosts
      : '';

    defaultInternalHosts.forEach(function (host) {
      addHost(hosts, host);
    });

    addHost(hosts, window.location.hostname);
    addHost(hosts, configuredHosts);

    return hosts;
  }

  function isExternalHref(href, internalHosts) {
    var url;

    if (!href) {
      return false;
    }

    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return false;
    }

    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return false;
    }

    return !internalHosts.has(normalizeHostname(url.hostname));
  }

  function addSafeRel(link) {
    var relParts = (link.getAttribute('rel') || '')
      .split(/\s+/)
      .filter(Boolean);
    var relValues = new Set(relParts);

    relValues.add('noopener');
    relValues.add('noreferrer');

    link.setAttribute('rel', Array.from(relValues).join(' '));
  }

  function markExternalLinks(root) {
    var internalHosts = getInternalHosts();
    var links = root.querySelectorAll ? root.querySelectorAll('a[href]') : [];

    links.forEach(function (link) {
      if (!isExternalHref(link.getAttribute('href'), internalHosts)) {
        return;
      }

      link.setAttribute('target', '_blank');
      addSafeRel(link);
    });
  }

  function observeNewLinks() {
    if (!window.MutationObserver || !document.documentElement) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) {
            return;
          }

          if (node.matches && node.matches('a[href]')) {
            markExternalLinks({
              querySelectorAll: function () {
                return [node];
              }
            });
          }

          markExternalLinks(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    markExternalLinks(document);
    observeNewLinks();
  }

  window.OMPExternalLinks = {
    getInternalHosts: getInternalHosts,
    isExternalHref: isExternalHref,
    markExternalLinks: markExternalLinks
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
